import React from "react";
import Table from "sulu-admin-bundle/components/Table";
import styles from "./passport-statistics-page.module.scss";

const { Header, Body, Row, Cell, HeaderCell } = Table;

const AGE_GROUPS = ["0-7", "8-9", "10-11", "12-13", "14-15", "16-17", "18+"];

// Association view: table with clubs as rows, age group columns per m/w
const AssociationView = ({ data, t }) => {
    const clubs = data.clubs || [];

    const totals = { total: 0 };
    clubs.forEach((club) => {
        totals.total += club.total || 0;
        (club.ageGroups || []).forEach((ag) => {
            const entry =
                totals[ag.label] || (totals[ag.label] = { male: 0, female: 0 });
            entry.male += ag.male || 0;
            entry.female += ag.female || 0;
        });
    });

    return (
        <div className={styles.tableWrapper}>
            <Table skin="dark">
                <Header
                    allSelected={false}
                    selectInFirstCell={false}
                    skin="dark"
                >
                    <HeaderCell>
                        {t("dhb.passport_statistics.column.club")}
                    </HeaderCell>
                    {AGE_GROUPS.map((ag) => (
                        <React.Fragment key={ag}>
                            <HeaderCell className={styles.ageGroupHeader}>
                                {ag} m
                            </HeaderCell>
                            <HeaderCell className={styles.ageGroupHeader}>
                                {ag} w
                            </HeaderCell>
                        </React.Fragment>
                    ))}
                    <HeaderCell className={styles.headerCell}>
                        {t("dhb.passport_statistics.column.total")}
                    </HeaderCell>
                </Header>
                <Body selectInFirstCell={false}>
                    {clubs.map((club) => {
                        const agMap = {};
                        (club.ageGroups || []).forEach((ag) => {
                            agMap[ag.label] = ag;
                        });

                        return (
                            <Row key={club.id}>
                                <Cell>{club.name}</Cell>
                                {AGE_GROUPS.map((ag) => {
                                    const stat = agMap[ag] || {};
                                    return (
                                        <React.Fragment key={ag}>
                                            <Cell className={styles.numberCell}>
                                                {stat.male ?? 0}
                                            </Cell>
                                            <Cell className={styles.numberCell}>
                                                {stat.female ?? 0}
                                            </Cell>
                                        </React.Fragment>
                                    );
                                })}
                                <Cell className={styles.totalCell}>
                                    {club.total ?? 0}
                                </Cell>
                            </Row>
                        );
                    })}
                    <Row className={styles.totalRow}>
                        <Cell>
                            <strong>
                                {t("dhb.passport_statistics.totals")}
                            </strong>
                        </Cell>
                        {AGE_GROUPS.map((ag) => {
                            const entry = totals[ag] || {};
                            return (
                                <React.Fragment key={ag}>
                                    <Cell className={styles.numberCell}>
                                        <strong>{entry.male || 0}</strong>
                                    </Cell>
                                    <Cell className={styles.numberCell}>
                                        <strong>{entry.female || 0}</strong>
                                    </Cell>
                                </React.Fragment>
                            );
                        })}
                        <Cell className={styles.totalCell}>{totals.total}</Cell>
                    </Row>
                </Body>
            </Table>
        </div>
    );
};

export default AssociationView;
